import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import {
  BLACK_HOLE_SCENE_INDEX,
  SCENE_DURATION,
  TOTAL_SCENES,
} from "../constants/sceneConfig";

export function WorldMover({ children }) {
  const groupRef = useRef();

  useFrame((state) => {
    if (!groupRef.current) return;
    const time = state.clock.elapsedTime;
    const idx = Math.floor((time / SCENE_DURATION) % TOTAL_SCENES);
    const localTime = time % SCENE_DURATION;

    if (idx === BLACK_HOLE_SCENE_INDEX) {
      const dist = smoothstep(0, 8, localTime) * 10.0;
      const rot = smoothstep(0, 8, localTime) * 0.3;

      groupRef.current.position.set(0, 0, -dist);
      groupRef.current.rotation.set(0, rot, 0);
    } else {
      groupRef.current.position.set(0, 0, 0);
      groupRef.current.rotation.set(0, 0, 0);
    }
  });

  return <group ref={groupRef}>{children}</group>;
}

function smoothstep(min, max, value) {
  const x = Math.max(0, Math.min(1, (value - min) / (max - min)));
  return x * x * (3 - 2 * x);
}
